import React from 'react';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { api } from '../../api/chat';
import { refreshBlocked } from '../../redux/chat.redux';
import { avatarText } from '../../utils/format';
import PanelShell from './panel-shell';

interface Props {
  onClose: () => void;
  embedded?: boolean;
}

export default function BlockedPanel({ onClose, embedded }: Props) {
  const dispatch = useAppDispatch();
  const blocked = useAppSelector((s) => s.chat.blocked);

  const unblock = async (userId: number) => {
    try {
      await api.unblockUser(userId);
      dispatch(refreshBlocked());
    } catch (err: any) {
      alert(err?.message || '操作失败');
    }
  };

  return (
    <PanelShell title="黑名单" onClose={onClose} embedded={embedded}>
      <Box sx={{ p: 1.5 }}>
        {blocked.length === 0 ? (
          <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mt: 4 }}>
            黑名单为空
          </Typography>
        ) : (
          <List disablePadding>
            {blocked.map((u) => (
              <ListItem key={u.id} sx={{ px: 0.5, mb: 1, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                <ListItemAvatar>
                  <Avatar src={u.avatar || undefined}>{avatarText(u)}</Avatar>
                </ListItemAvatar>
                <ListItemText primary={u.nickname || u.username} secondary={u.username} />
                <Button size="small" variant="outlined" onClick={() => unblock(u.id)}>
                  解除拉黑
                </Button>
              </ListItem>
            ))}
          </List>
        )}
      </Box>
    </PanelShell>
  );
}
